import React, { useState } from "react";
import { getClassName } from "@sscs/utils";
import styles from "./fileDropZone.module.scss";
const FileDropZone = ({ size, onDrop, title, description, dropTitle, icon, className, children, }) => {
    const [isDragOver, setIsDragOver] = useState(false);
    const hidden = { [styles.hidden]: isDragOver };
    return (React.createElement("div", { className: getClassName(styles.root, styles[size], className, {
            [styles.active]: isDragOver,
        }), onDrop: (event) => {
            event.preventDefault();
            setIsDragOver(false);
            onDrop(Array.from(event.dataTransfer.files));
        }, onDragOver: (event) => {
            event.preventDefault();
            setIsDragOver(true);
        }, onDragLeave: (event) => {
            if (event.relatedTarget instanceof Node &&
                event.currentTarget.contains(event.relatedTarget)) {
                return;
            }
            event.preventDefault();
            setIsDragOver(false);
        } },
        React.createElement("div", { className: styles.prompt },
            React.createElement("div", { className: styles.icon }, icon),
            React.createElement("div", { className: styles.text },
                React.createElement("span", { className: styles.title }, isDragOver ? dropTitle : title),
                React.createElement("span", { className: getClassName(styles.description, hidden) }, description)),
            React.createElement("div", { className: getClassName(styles.action, hidden) }, children)),
        React.createElement("span", { className: styles["edge-solid"] }),
        React.createElement("span", { className: styles["edge-dashed"] })));
};
export default FileDropZone;
//# sourceMappingURL=FileDropZone.js.map